import {set} from '@servicenow/ui-utils';

/**
 * Utility function to update resolved value with a path
 */
export default function updateResolvedValue(alreadyResolvedValue, path, newValue) {
	if (!path) return newValue;
	//deals with scenario when selected property has a path, e.g. arrayProp[1], objProp.foo
	const updatedValue = alreadyResolvedValue;
	set(updatedValue, path, newValue);
	return updatedValue;
}
